import { search } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);

const path = `${process.env.REACT_APP_URL_API_REPORTS}/cashflow`;
const documentsHubPath = `${process.env.REACT_APP_URL_API_DOC_HUB}/reports`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findCashFlow(filterProps) {
  const queryParams = [];
  Object.entries(filterProps).forEach(([key, value]) => {
    if (value) queryParams.push(`${key}=${value}`);
  });

  const query = `?${queryParams.join("&")}`;
  return search(`${path}${queryParams.length ? query : ""}`, "GET", headers);
}

export async function printCashFlowPDF({
  title,
  type = "DETALHADO",
  group = "DIA",
  orientation,
  companyName,
  companyFantasy,
  headerLogo,
  footerLogo,
  userLogged,
  period,
  useCategoryGroup = false,
  useInitialBalance = false,
  initialBalanceTotal,
  initialBalanceGroup,
  filter = [],
  generalAccountReceivableTotal,
  generalAccountNotReceivableTotal,
  generalAccountPayableTotal,
  generalAccountNotPayableTotal,
  generalBalance,
  cashFlowGroup,
}) {
  const url = `${documentsHubPath}/cash-flow/generate`;
  const body = {
    title,
    type,
    group,
    orientation,
    companyName,
    companyFantasy,
    headerLogo,
    footerLogo,
    login: userLogged,
    filter,
    startDate: period.startDate,
    endDate: period.endDate,
    useCategoryGroup,
    useInitialBalance,
    initialBalanceTotal,
    initialBalanceGroup,
    generalAccountReceivableTotal,
    generalAccountNotReceivableTotal,
    generalAccountPayableTotal,
    generalAccountNotPayableTotal,
    generalBalance,
    cashFlowGroup,
  };

  return search(`${url}`, "POST", headers, body);
}
